export function isMobileDevice() {
	const userAgent = navigator.userAgent || navigator.vendor;
	return (
		/android|avantgo|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(40|60)|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|iPad/i.test(
			userAgent,
		) ||
		(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
	);
}
